import React from 'react';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';
import './ShippingPolicy.css';

const ShippingPolicy = () => {
  const { t } = useI18n();
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: t('shipping.faq.where.question'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: t('shipping.faq.where.answer'),
        },
      },
      {
        '@type': 'Question',
        name: t('shipping.faq.time.question'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: t('shipping.faq.time.answer'),
        },
      },
      {
        '@type': 'Question',
        name: t('shipping.faq.currency.question'),
        acceptedAnswer: {
          '@type': 'Answer',
          text: t('shipping.faq.currency.answer'),
        },
      },
    ],
  };

  return (
    <main className="shipping-page">
      <Seo
        title={t('shipping.seoTitle')}
        description={t('shipping.seoDescription')}
        path="/shipping"
        structuredData={faqSchema}
      />
      <h1>{t('shipping.title')}</h1>
      <p>{t('shipping.intro')}</p>
      <h2>{t('shipping.timingTitle')}</h2>
      <p>{t('shipping.timing')}</p>
      <h2>{t('shipping.carrierTitle')}</h2>
      <p>{t('shipping.carrier')}</p>
      <h2>{t('shipping.currencyTitle')}</h2>
      <p>{t('shipping.currency')}</p>
      <h2>{t('shipping.questionsTitle')}</h2>
      <p>{t('shipping.questions')}</p>
    </main>
  );
};

export default ShippingPolicy;
